import React from 'react';
import { useSelector } from 'react-redux';

const MiniCart = () => {
  const { quantity, checkoutUrl } = useSelector(
    (state) => state.cart
  );

  return (
    <>
      <a
        className="cart__link--block"
        rel="nofollow"
        href={checkoutUrl}
      >
        <i className="cart__icon">
          {quantity > 0 && <span className="cart__quantity">{quantity}</span>}
        </i>
      </a>
    </>
  );
};

export default MiniCart;
